import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Recording } from "../../types/Recording";
import { getQueue, postRemoveRecordingFromQueue } from "../../components/apis/music-api";
import callApi from "../../components/call-api/call-api";
import { format } from "../../components/text-helper/text-helper";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import { faArrowRight, faRefresh, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonBar from "../../components/button-bar/ButtonBar";
import { useMusicStore } from "../../components/store/store";

const Queue = () => {
    const { getAccessToken } = useContext(AuthenticationContext);
    const [queueList , setQueueList] = useState<Recording[]>([]);
    const { currentTrack } = useMusicStore();

    const loadQueue = async () => {
        const accessToken = getAccessToken();
        await callApi(getQueue(accessToken), setQueueList);
    }

    useEffect(() => {
        loadQueue();
    }, []);

    useEffect(() => {
        loadQueue();
    }, [currentTrack]);

    const deleteItem = async (recording: Recording) => {
        const accessToken = getAccessToken();
        await callApi(postRemoveRecordingFromQueue(accessToken, recording), loadQueue);
        loadQueue();
    }

    return (
        <>
      <ButtonBar
        leftButtons={[]}
        rightButtons={[
          <Button variant="contained" size="small" onClick={loadQueue}>
            <FontAwesomeIcon fontSize="small" color="primary" icon={faRefresh} className="icon" />
            Refresh
          </Button>
        ]}
      />
        <Stack>
            <Box>
                <Typography variant='h6'>Queue</Typography>
            </Box>
        </Stack>
        <Stack gap={1} sx={{ marginTop: '8px' }}>
            {queueList?.map((recording: Recording, index: number) =>            
                <Box key={`recording-${index}`} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Stack direction="row" spacing={3} alignItems="center">
                        <Box sx={{ width: '24px', textAlign: 'center' }}>
                            {index === 0
                                ? <FontAwesomeIcon fontSize="medium" color="primary" icon={faArrowRight} className="icon" style={{ marginRight: 0 }} />
                                : 
                            <Button
                                variant="contained"
                                size="small"
                                style={{ minWidth: 0, marginTop: '-6px' }}
                                onClick={() => deleteItem(recording)}
                            >
                                <FontAwesomeIcon fontSize="small" color="primary" icon={faTrash} className="icon" style={{ marginRight: 0 }} />
                            </Button>
                            }
                        </Box>
                        <Box>
                            {format(recording.artistName)} - {recording.albumTitle} - {recording.track?.name}
                        </Box>
                    </Stack>
                </Box>
            )}
        </Stack>
        </>
    );
};

export default Queue;